import React, { useEffect } from "react";
import Loader from "./Live/Loader";
import { useNavigate } from "react-router-dom";

export default function RelatedCourses({ loader, courses }) {
  const navigate = useNavigate();

  const handleCourseClick = (courseId) => {
    // Navigate to the course details page
    navigate(`/dashboard/courses/details/${courseId}`);
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-5 bg-white p-8 w-full rounded-xl">
        <h3 className="text-4xl font-medium text-primary tracking-tight">
          RELATED COURSES
        </h3>
        <button className="flex justify-between space-x-4 items-center text-xl text-primary font-normal hover:underline transition">
          <span> Show all</span>
          <svg
            width="15"
            height="25"
            viewBox="0 0 15 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 2L13 12.5L2 23"
              stroke="#858585"
              stroke-width="4"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2 2L13 12.5L2 23"
              stroke="#134F98"
              stroke-width="4"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
        {loader && <Loader />}
        {courses?.lenght < 0 && (
          <span> There are no related courses for this course </span>
        )}
        {courses?.map((course, idx) => (
          <div
            key={idx}
            className="bg-white rounded-lg shadow py-12 px-4 flex flex-col items-center hover:shadow-lg transition space-y-4 cursor-pointer"
            onClick={() => {
              handleCourseClick(course.id);
            }}
          >
            <img
              src={course.image_url}
              alt={course.title}
              className="w-[20rem] h-[30rem] object-cover rounded mb-3"
            />
            <h4 className="md:text-3xl font-normal text-primary text-base mb-1 text-center leading-tight">
              {course.title}
            </h4>
            <p className="md:text-md font-normal text-sm text-[#929292] text-center leading-tight">
              {course.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
